'use client'

import { useState } from 'react'
import Modal from '@/components/ui/modal'
import { EventForm } from './event-form'

interface EventFormModalProps {
  isOpen: boolean
  onClose: () => void
  initialDate?: Date
  initialEndDate?: Date
  onEventCreated?: (eventId: string) => void
  defaultMeetupId?: string
}

function EventFormModal({
  isOpen,
  onClose,
  initialDate,
  initialEndDate,
  onEventCreated,
  defaultMeetupId,
}: EventFormModalProps) {
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleSuccess = (eventId: string) => {
    setIsSubmitting(true)
    if (onEventCreated) {
      onEventCreated(eventId)
    }
    setIsSubmitting(false)
    onClose()
  }

  // Create a safe version of onClose that can be undefined
  const safeOnClose = isSubmitting ? undefined : onClose

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Create Event"
      size="lg"
      closeOnOutsideClick={!isSubmitting}
      closeOnEsc={!isSubmitting}
    >
      <EventForm
        initialDate={initialDate}
        initialEndDate={initialEndDate}
        onSuccess={handleSuccess}
        onCancel={safeOnClose}
        defaultMeetupId={defaultMeetupId}
      />
    </Modal>
  )
}

export { EventFormModal }
